(function(konto) {
	konto.ao = {};
} (konto = window.konto));